import { stringToEnum } from '@snap-types/models/common';

export enum PriceSegmentType {
  CustomerPotential = 'CustomerPotential',
  CustomerPortals = 'CustomerPortals',
  ProductOperationsCount = 'ProductOperationsCount',
  ProductComplexity = 'ProductComplexity',
  MarketIndustry = 'MarketIndustry',
  LastTransactionAge = 'LastTransactionAge',
  LastGrossMargin = 'LastGrossMargin',
}

export const priceSegmentTypeSchema = stringToEnum(PriceSegmentType);
